import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/**計上月度のENUM*/
enum EntryDateSelection {
  currentMonth = '101',
  currentQuarter = '102',
  currentHalf = '103',
  currentPeriod = '104',
  quarter1 = '105',
  quarter2 = '106',
  quarter3 = '107',
  quarter4 = '108',
}

const nameConfig = {
  currentMonth: new Map([
    [Locale.ja, '当月'],
    [Locale.en, 'Current Month'],
  ]),
  currentQuarter: new Map([
    [Locale.ja, '当四半期'],
    [Locale.en, 'Current Quarter'],
  ]),
  currentHalf: new Map([
    [Locale.ja, '当半期'],
    [Locale.en, 'Current Half'],
  ]),
  currentPeriod: new Map([
    [Locale.ja, '当期'],
    [Locale.en, 'Current Period'],
  ]),
  quarter1: new Map([
    [Locale.ja, '第1四半期'],
    [Locale.en, 'Quarter 1'],
  ]),
  quarter2: new Map([
    [Locale.ja, '第2四半期'],
    [Locale.en, 'Quarter 2'],
  ]),
  quarter3: new Map([
    [Locale.ja, '第3四半期'],
    [Locale.en, 'Quarter 3'],
  ]),
  quarter4: new Map([
    [Locale.ja, '第4四半期'],
    [Locale.en, 'Quarter 4'],
  ]),
};

const toEnum = rawValueToEnum(EntryDateSelection, EntryDateSelection.currentMonth);
const toDisplay = enumToName(EntryDateSelection, nameConfig);
const toDisplayWithPrefix = enumToName(EntryDateSelection, nameConfig, { prefix: true });

export const entryDateSelection = {
  enum: EntryDateSelection,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { EntryDateSelection };
